import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "../Admin/TeamRequests.css"; 
import PopupMessage from "../PopupMessage/PopupMessage";
import { fetchTeamRequests, updatePilotStatus } from "../Apis/AdminApis";
import pavamanLogo from "../images/drone.png"; 
import { useNavigate } from "react-router-dom";

const ActiveTeams = () => {
  const navigate = useNavigate();
  const [allPilots, setAllPilots] = useState([]);
  const [activePilots, setActivePilots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("grid");
  const [selectedPilot, setSelectedPilot] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionPilot, setActionPilot] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [isActionProcessing, setIsActionProcessing] = useState(false); 

  const statusMap = {
    0: { label: "Pending", value: "pending", color: "#FFA500", bg: "#FFF3CD", icon: "⏳" },
    1: { label: "Active", value: "active", color: "#00B894", bg: "#D4EDDA", icon: "✓" },
    2: { label: "Rejected", value: "rejected", color: "#FF4757", bg: "#F8D7DA", icon: "✗" },
    3: { label: "Blocked", value: "blocked", color: "#6C757D", bg: "#E2E3E5", icon: "🚫" }
  };

  useEffect(() => {
    loadAllPilots();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

const isPilotActive = (devices) => {
  if (!devices || devices.length === 0) return false;

  // Sort devices by latest created_on
  const sortedDevices = [...devices].sort(
    (a, b) =>
      new Date(b.created_on).getTime() -
      new Date(a.created_on).getTime()
  );

  const latestDevice = sortedDevices[0];

  // Pilot is active only when the LATEST device
  // is approved and active.
  return (
    Number(latestDevice?.admin_approved) === 1 &&
    latestDevice?.is_active === true
  );
};

const getPilotStatusFromDevices = (devices) => {
  if (!devices || devices.length === 0) {
    return statusMap[0];
  }

  // Always use the latest device status
  const sortedDevices = [...devices].sort(
    (a, b) =>
      new Date(b.created_on).getTime() -
      new Date(a.created_on).getTime()
  );

  const latestDevice = sortedDevices[0];

  const adminApproved = Number(
    latestDevice?.admin_approved
  );

  const isActive =
    latestDevice?.is_active === true;

  // Approved + active = Active
  if (adminApproved === 1 && isActive) {
    return statusMap[1];
  }

  // Pending
  if (adminApproved === 0) {
    return statusMap[0];
  }

  // Rejected
  if (adminApproved === 2) {
    return statusMap[2];
  }

  // Fallback
  return statusMap[3];
};

const getDeviceInfoFromDevices = (devices) => {
  if (!devices || devices.length === 0) {
    return {
      device_id: "Not Set",
      device_count: 0,
      approved_count: 0,
      approved_devices: [],
      pending_devices: [],
      rejected_devices: [],
      latest_device: null
    };
  }

  // Sort newest device first
  const sortedDevices = [...devices].sort(
    (a, b) =>
      new Date(b.created_on).getTime() -
      new Date(a.created_on).getTime()
  );

  const latestDevice = sortedDevices[0];

  const approvedDevices = devices.filter(
    d =>
      Number(d.admin_approved) === 1 &&
      d.is_active === true
  );

  const pendingDevices = devices.filter(
    d => Number(d.admin_approved) === 0
  );

  const rejectedDevices = devices.filter(
    d => Number(d.admin_approved) === 2
  );

  return {
    // Latest device ID
    device_id:
      latestDevice?.device_id ||
      "Not Set",

    device_count: devices.length,

    approved_count: approvedDevices.length,

    approved_devices: approvedDevices,

    pending_devices: pendingDevices,

    rejected_devices: rejectedDevices,

    latest_device: latestDevice
  };
};

  const loadAllPilots = async () => {
    try {
      setLoading(true);
      const payload = {};

      const res = await fetchTeamRequests(payload);

      if (res?.error) {

  // ✅ Session expired handling
  if (res?.error?.includes("Unauthorized")) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    setAllPilots([]);
    setActivePilots([]);
    setLoading(false);
    return;
  }

  console.error(res.error);
  setPopupMessage(res.error);
  setPopupType("error");
  setPopupOpen(true);

  setAllPilots([]);
  setActivePilots([]);
  setLoading(false);
  return;
}

      const pilotsArray = Array.isArray(res?.pilots) ? res.pilots : [];

      const formattedData = pilotsArray.map((pilot) => {
        const devices = pilot.devices || [];
        const status = getPilotStatusFromDevices(devices);
        const deviceInfo = getDeviceInfoFromDevices(devices);
        const isActive = isPilotActive(devices);

return {
  // Basic pilot information
  id: pilot.id,
  name: pilot.name || "Unknown Pilot",
  firstName: pilot.first_name || pilot.name?.split(" ")[0] || "",
  lastName: pilot.last_name || pilot.name?.split(" ").slice(1).join(" ") || "",
  email: pilot.email || "",
  mobile_no: pilot.mobile_no || "",

  // Company information
  company_name: pilot.company_name || "",
  admin_id: pilot.admin_id || null,
  admin_name: pilot.admin_name || "",
  is_superadmin_company: pilot.is_superadmin_company || false,
  is_dgca_company: pilot.is_dgca_company || false,
// Pilot account/registration status
pilot_status: pilot.status,

// Latest device approval status
device_status: deviceInfo.latest_device
  ? Number(deviceInfo.latest_device.admin_approved)
  : null,

// Latest device active status
device_is_active:
  deviceInfo.latest_device?.is_active === true,

// Final Active Teams status
is_active_pilot: isActive,

  // UI status
  status: status.value,
  statusLabel: status.label,
  statusColor: status.color,
  statusBg: status.bg,
  statusIcon: status.icon,

  // Signup key
  signup_key: pilot.signup_key || null,

  // Device information
  devices,
  device_count: deviceInfo.device_count,
  approved_count: deviceInfo.approved_count,
  device_id: deviceInfo.device_id,
  approved_devices: deviceInfo.approved_devices,
  pending_devices: deviceInfo.pending_devices,
  rejected_devices: deviceInfo.rejected_devices,

  // Login information
  login_on: pilot.login_on || null,
  login_status: pilot.login_status,
  logout_status: pilot.logout_status,
  logout_on: pilot.logout_on || null,

  // Created date
  created_on: pilot.created_on || null
};
      });

      setAllPilots(formattedData);
      const approvedPilots = formattedData.filter(
        (pilot) => pilot.is_active_pilot === true
      );

      setActivePilots(approvedPilots);
      setCurrentPage(1); 
      setLoading(false);
    } catch (error) {
      console.error("Load pilots error:", error);
        if (
    error?.response?.status === 401 ||
    error?.response?.data?.error?.includes("Unauthorized")
  ) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    setAllPilots([]);
    setActivePilots([]);
    setLoading(false);

    return;
  }

  // Other errors
  setPopupMessage(
    error?.response?.data?.error || "Failed to load pilots"
  );
  setPopupType("error");
  setPopupOpen(true);
  
      setAllPilots([]);
      setActivePilots([]);
      setLoading(false);
    }
  };

 const handleStatusUpdate = async (pilot, action) => {
  try {
    setIsActionProcessing(true); 
    
    const adminApprovedValue = action === 'reject' ? 2 : 1;
    
    const payload = {
      pilot_email: pilot.email,
      admin_approved: adminApprovedValue,
    };

    const res = await updatePilotStatus(payload);

    if (res?.error) {

  // ✅ Session expired handling
  if (res?.error?.includes("Unauthorized")) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    setIsActionProcessing(false);
    return;
  }

  setPopupMessage(res.error);
  setPopupType("error");
  setPopupOpen(true);
  setIsActionProcessing(false);
  return;
}
    const successMessage = res?.message || 
      (action === 'reject' ? "Pilot rejected and device blocked successfully" : "Pilot activated successfully");
    
    setPopupMessage(successMessage);
    setPopupType("success");
    setPopupOpen(true);
    
    setShowActionModal(false);
    setActionPilot(null);
    setActionType(null);
    
    await loadAllPilots();
  } catch (err) {
    console.error(err);
        if (
      err?.response?.status === 401 ||
      err?.response?.data?.error?.includes("Unauthorized")
    ) {
      setPopupMessage("Session expired, redirecting to login page");
      setPopupType("error");
      setPopupOpen(true);

      setTimeout(() => {
        navigate("/login");
      }, 2000);

      return;
    }
    setPopupMessage(err?.response?.data?.error || "Failed to update pilot status");
    setPopupType("error");
    setPopupOpen(true);
  } finally {
    setIsActionProcessing(false); 
  }
};

  const openActionModal = (pilot, type) => {
    setActionPilot(pilot);
    setActionType(type);
    setShowActionModal(true);
  };

  const closeActionModal = () => {
    if (isActionProcessing) return;
    setShowActionModal(false);
    setActionPilot(null);
    setActionType(null);
  };

  const handleViewClick = (pilot) => {
    navigate("/admin/teams/active/pilot-details", {
      state: { pilot, from: "active" }
    });
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setSelectedPilot(null);
  };

  const filteredActivePilots = activePilots.filter((pilot) => {
    const matchesSearch = 
      pilot.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      pilot.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      pilot.mobile_no?.includes(searchTerm);
    
    return matchesSearch;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPilots = filteredActivePilots.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredActivePilots.length / itemsPerPage);

  const onlineCount = activePilots.filter(pilot => 
    pilot.login_status === true || pilot.login_status === 1
  ).length;
  
  const totalActiveCount = activePilots.length;
  
  const devicesConnectedCount = activePilots.reduce((total, pilot) => 
    total + (pilot.approved_count || 0), 0
  );

  const loggedInTodayCount = activePilots.filter(pilot => {
    if (!pilot.login_on) return false;
    try {
      const today = new Date().toDateString();
      const loginDate = new Date(pilot.login_on).toDateString();
      return loginDate === today;
    } catch {
      return false;
    }
  }).length;

  const formatMobile = (mobile) => {
    if (!mobile) return "N/A";
    return mobile.startsWith('+91') ? mobile : `+91 ${mobile}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Never";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return dateString;
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "Never";
    try {
      return new Date(dateString).toLocaleString();
    } catch {
      return dateString;
    }
  };

  const renderActionButtons = (pilot) => {
    return (
      <>
        <button
          className="tr-btn-block"
          onClick={() => openActionModal(pilot, 'reject')}
        >
          🚫 Reject
        </button>
        <button
          className="tr-btn-view"
          onClick={() => handleViewClick(pilot)}
        >
          👁️ View Details
        </button>
      </>
    );
  };

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Active Team Members</h1>
            <p className="dashboard-subtitle">Manage approved pilots and their active devices</p>
          </div>
        </div>

        <div className="tr-filter-bar">
          <div className="tr-results-info">
            <span className="tr-results-count">
              Showing {filteredActivePilots.length} of {totalActiveCount} active pilots
            </span>
            {searchTerm && (
              <span className="tr-search-term">
                Search: "{searchTerm}"
                <button onClick={() => setSearchTerm("")}>Clear</button>
              </span>
            )}
          </div>

          <div className="tr-view-controls">
            <div className="tr-view-toggle">
              <button
                className={`tr-view-btn ${viewMode === "grid" ? "tr-active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                ⏹️ Grid
              </button>
              <button
                className={`tr-view-btn ${viewMode === "list" ? "tr-active" : ""}`}
                onClick={() => setViewMode("list")}
                title="List View"
              >
                ≡ List
              </button>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="custom-loading-container">
            <img
              src={pavamanLogo}
              alt="Loading"
              className="spinning-logo"
            />
            <p className="loading-text">
              Loading active pilots data...
            </p>
          </div>
        ) : (
          <>
            {viewMode === "grid" ? (
              <>
                <div className="tr-grid">
                  {currentPilots.map((pilot) => (
                    <div
                      key={pilot.id}
                      className="tr-card"
                      style={{ borderTopColor: pilot.statusColor }}
                    >
                      <div className="tr-card-header">
                        <div className="tr-avatar" style={{ background: pilot.statusColor }}>
                          {pilot.firstName?.charAt(0) || pilot.name?.charAt(0) || "P"}
                        </div>

                        <div className="tr-card-info">
                          <div className="tr-card-name-row">
                            <h3 className="tr-card-name">{pilot.name}</h3>
                            <span className="tr-status-badge" style={{ background: pilot.statusBg, color: pilot.statusColor }}>
                              {pilot.statusIcon} {pilot.login_status === true || pilot.login_status === 1 ? "Online" : "Offline"}
                            </span>
                          </div>
                          <p className="tr-card-email">{pilot.email}</p>
                          <div className="tr-card-meta">
                            <span className="tr-meta-item">
                              📱 {formatMobile(pilot.mobile_no)}
                            </span>
                            {pilot.approved_count > 1 && (
                              <span className="tr-meta-item">
                                📱 +{pilot.approved_count - 1} devices
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="tr-card-details">
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Registered:</span>
                          <span className="tr-detail-value">{formatDate(pilot.created_on)}</span>
                        </div>
                        {pilot.is_dgca_company === true && (
  <div className="tr-detail-row">
    <span className="tr-detail-label">Signup Key:</span>
    <span className="tr-detail-value">
      {pilot.signup_key || "Not Set"}
    </span>
  </div>
)}
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Last Login:</span>
                          <span className="tr-detail-value">{formatDate(pilot.login_on)}</span>
                        </div>
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Approved Devices:</span>
                          <span className="tr-detail-value">{pilot.approved_count || 0}</span>
                        </div>
                        <div className="tr-detail-row">
                          <span className="tr-detail-label">Login Status:</span>
                          <span className={`tr-detail-value ${pilot.login_status === true || pilot.login_status === 1 ? "tr-online" : "tr-offline"}`}>
                            {pilot.login_status === true || pilot.login_status === 1 ? "Online" : "Offline"}
                          </span>
                        </div>
                      </div>

                      <div className="tr-card-divider"></div>

                      <div className="tr-action-buttons">
                        {renderActionButtons(pilot)}
                      </div>
                    </div>
                  ))}
                </div>

                {filteredActivePilots.length > itemsPerPage && (
                  <div className="pagination-container">
                    <div className="pagination-controls">
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← Previous
                      </button>
                      
                      <div className="page-numbers">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNumber;
                          if (totalPages <= 5) {
                            pageNumber = i + 1;
                          } else if (currentPage <= 3) {
                            pageNumber = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNumber = totalPages - 4 + i;
                          } else {
                            pageNumber = currentPage - 2 + i;
                          }
                          
                          return (
                            <button
                              key={pageNumber}
                              className={`page-btn ${currentPage === pageNumber ? 'active' : ''}`}
                              onClick={() => setCurrentPage(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          );
                        })}
                      </div>
                      
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="tr-table-container">
                  <table className="tr-table">
                    <thead className="tr-thead">
                      <tr>
                        <th>Pilot</th>
                        <th>Contact</th>
                        <th>Login Status</th>
                        <th>Last Login</th>
                        {/* <th>Device Info</th> */}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPilots.map((pilot) => (
                        <tr key={pilot.id}>
                          <td>
                            <div className="tr-table-pilot">
                              <div className="tr-table-avatar" style={{ background: pilot.statusColor }}>
                                {pilot.firstName?.charAt(0) || pilot.name?.charAt(0) || "P"}
                                {/* <div className={`tr-table-online ${pilot.login_status === true || pilot.login_status === 1 ? "tr-online" : "tr-offline"}`}></div> */}
                              </div>
                              <div className="tr-table-pilot-info">
                                <div className="tr-table-name">{pilot.name}</div>
                                <div className="tr-table-email">{pilot.email}</div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="tr-table-contact">
                              <div>📱 {formatMobile(pilot.mobile_no)}</div>
                              <div>✉️ {pilot.email}</div>
                            </div>
                          </td>
                          <td>
                            <div className={`tr-table-login ${pilot.login_status === true || pilot.login_status === 1 ? "tr-online" : "tr-offline"}`}>
                              <span className="tr-status-dot"></span>
                              {pilot.login_status === true || pilot.login_status === 1 ? "Online" : "Offline"}
                            </div>
                          </td>
                          <td>
                            <div className="tr-table-date">{formatDate(pilot.login_on)}</div>
                          </td>
                          {/* <td>
                            <div className="tr-table-device-info">
                              <div>📊 Approved: {pilot.approved_count || 0}</div>
                              {pilot.pending_devices?.length > 0 && (
                                <div className="tr-pending-badge" style={{ fontSize: '12px', color: '#FFA500' }}>
                                  ⏳ {pilot.pending_devices.length} pending
                                </div>
                              )}
                            </div>
                          </td> */}
                          <td>
                            <div className="tr-table-actions">
                              <button
                                onClick={() => openActionModal(pilot, 'reject')}
                                className="tr-table-btn tr-btn-block"
                                title="Reject Pilot"
                              >
                                🚫
                              </button>
                              <button 
                                onClick={() => handleViewClick(pilot)} 
                                className="tr-table-btn tr-btn-view"
                                title="View Details"
                              >
                                👁️
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {filteredActivePilots.length > itemsPerPage && (
                  <div className="pagination-container">
                    <div className="pagination-controls">
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        ← Previous
                      </button>
                      
                      <div className="page-numbers">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                          let pageNumber;
                          if (totalPages <= 5) {
                            pageNumber = i + 1;
                          } else if (currentPage <= 3) {
                            pageNumber = i + 1;
                          } else if (currentPage >= totalPages - 2) {
                            pageNumber = totalPages - 4 + i;
                          } else {
                            pageNumber = currentPage - 2 + i;
                          }
                          
                          return (
                            <button
                              key={pageNumber}
                              className={`page-btn ${currentPage === pageNumber ? 'active' : ''}`}
                              onClick={() => setCurrentPage(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          );
                        })}
                      </div>
                      
                      <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}

            {filteredActivePilots.length === 0 && (
              <div className="tr-no-results">
                <div className="tr-no-results-icon">👨‍✈️</div>
                <h3>No active pilots found</h3>
                <p>
                  {searchTerm 
                    ? "No active pilots match your search criteria"
                    : "There are no pilots with approved devices in the system"}
                </p>
              </div>
            )}
          </>
        )}
      </div>

{showActionModal && actionPilot && (
  <div className="tr-modal-overlay" onClick={closeActionModal}>
    <div className="tr-modal-content tr-modal-small" onClick={(e) => e.stopPropagation()}>
      <div className="tr-modal-header">
        <h2>Reject Pilot</h2>
        <button className="tr-modal-close" onClick={closeActionModal} disabled={isActionProcessing}>✕</button>
      </div>
      <div className="tr-modal-body">
        <div className="tr-confirm-container">
          <div className="tr-confirm-icon tr-confirm-reject">
            🚫
          </div>
          <p className="tr-confirm-text">
            Are you sure you want to Reject <strong>{actionPilot.name}</strong>?
          </p>
          <p className="tr-confirm-subtext">
            The pilot will be rejected and their device will be blocked. 
            They will not be able to access the platform until reactivated.
          </p>
          <div className="tr-confirm-buttons">
            <button 
              className="tr-confirm-cancel" 
              onClick={closeActionModal}
              disabled={isActionProcessing}
            >
              Cancel
            </button>
            <button 
              className="tr-confirm-reject-btn"
              onClick={() => handleStatusUpdate(actionPilot, 'reject')}
              disabled={isActionProcessing}
            >
              {isActionProcessing ? (
                <>
                  <span className="tr-spinner-small"></span>
                  Processing...
                </>
              ) : (
                'Yes, Rejected'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default ActiveTeams;